import { createContext, useContext, useCallback, useState, useRef, useEffect, useMemo } from 'react';
import { Moralis } from 'moralis';
import { jsx, jsxs } from 'react/jsx-runtime';

var MoralisContext = createContext(null);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

var ReactMoralisError = /** @class */ (function (_super) {
    __extends(ReactMoralisError, _super);
    function ReactMoralisError(message) {
        var _this = _super.call(this, "[react-moralis]: " + message) || this;
        _this.name = "ReactMoralisError";
        _this.message = message;
        return _this;
    }
    ReactMoralisError.isReactMoraliserrpr = true;
    return ReactMoralisError;
}(Error));
var NoMoralisContextProviderError = /** @class */ (function (_super) {
    __extends(NoMoralisContextProviderError, _super);
    function NoMoralisContextProviderError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "NoMoralisContextProviderError";
        return _this;
    }
    return NoMoralisContextProviderError;
}(ReactMoralisError));
var NotAuthenticatedError = /** @class */ (function (_super) {
    __extends(NotAuthenticatedError, _super);
    function NotAuthenticatedError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "NotAuthenticatedError";
        return _this;
    }
    return NotAuthenticatedError;
}(ReactMoralisError));
var ValidationError = /** @class */ (function (_super) {
    __extends(ValidationError, _super);
    function ValidationError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = "ValidationError";
        return _this;
    }
    return ValidationError;
}(ReactMoralisError));

var useMoralis = function () {
    var moralisContext = useContext(MoralisContext);
    if (!moralisContext) {
        throw new NoMoralisContextProviderError("Make sure to only call useMoralis within a  <MoralisProvider>");
    }
    return moralisContext;
};

// do not edit .js files directly - edit src/index.jst



var react = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if("production"!==process.env.NODE_ENV){var i=Y[n],o=i?"function"==typeof i?i.apply(null,t):i:"unknown error nr: "+n;throw Error("[Immer] "+o)}throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return "'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return !!n&&!!n[Q]}function t(n){return !!n&&(function(n){if(!n||"object"!=typeof n)return !1;var r=Object.getPrototypeOf(n);if(null===r)return !0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return "function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!n.constructor[L]||s(n)||v(n))}function i$1(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n);})):n.forEach((function(t,e){return r(e,t,n)}));}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?(n.delete(r),n.add(t)):n[r]=t;}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]});}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i$1(n,(function(n,r){return d(r,!0)}),!0),n)}function h(){n(2);}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function _(){return "production"===process.env.NODE_ENV||U||n(0),U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r);}function g(n){O(n),n.p.forEach(S),n.p=null;}function O(n){n===U&&(U=n.l);}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.g=!0;}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.O||b("ES5").S(e,r,o),o?(i[Q].P&&(g(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q],r,e.u,e.s)):r=M(e,i,[]),g(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i$1(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i$1(3===e.i?new Set(o):o,(function(r,i){return A(n,e,o,r,i,t)})),x(n,o,!1),t&&n.u&&b("Patches").R(e,t,n.u,n.s);}return e.o}function A(e,i,o,a,c,s){if("production"!==process.env.NODE_ENV&&c===o&&n(5),r(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!r(v))return;e.m=!1;}if(t(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c);}}function x(n,r,t){void 0===t&&(t=!1),n.h.F&&n.m&&d(r,t);}function z(n,r){var t=n[Q];return (t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t);}}function k(n){n.P||(n.P=!0,n.l&&k(n.l));}function E(n){n.o||(n.o=l(n.t));}function R(n,r,t){var e=s(r)?b("MapSet").N(r,t):v(r)?b("MapSet").T(r,t):n.O?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return (t?t.A:_()).p.push(e),e}function D(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(r,c),u.I=!1;}else e=F(r,c);return i$1(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t));})),3===c?new Set(e):e}(e)}function F(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return "Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return "Unsupported patch operation: "+n},18:function(n){return "The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return "'current' expects a draft, got: "+n},23:function(n){return "'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t);})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=R(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.D[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return !0;E(n),k(n);}return n.o[r]===t&&"number"!=typeof t||(n.o[r]=t,n.D[r]=!0,!0)},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.D[r]=!1,E(n),k(n)):delete n.D[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11);},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12);}},on={};i$1(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)};})),on.deleteProperty=function(r,t){return "production"!==process.env.NODE_ENV&&isNaN(parseInt(t))&&n(13),en.deleteProperty.call(this,r[0],t)},on.set=function(r,t,e){return "production"!==process.env.NODE_ENV&&"length"!==t&&isNaN(parseInt(t))&&n(14),en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.O=B,this.F=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return (t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=R(e,r,void 0),v=!0;try{f=i(s),v=!1;}finally{v?g(c):O(c);}return "undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw g(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if((f=i(r))===H)return;return void 0===f&&(f=r),e.F&&d(f,!0),f}n(21,r);},this.produceWithPatches=function(n,r){return "function"==typeof n?function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))}:[e.produce(n,r,(function(n,r){t=n,i=r;})),t,i];var t,i;},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze);}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,O(i),o},i.finishDraft=function(r,t){var e=r&&r[Q];"production"!==process.env.NODE_ENV&&(e&&e.C||n(9),e.I&&n(10));var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n;},i.setUseProxies=function(r){r&&!B&&n(20),this.O=r;},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t.slice(e+1))}))},e}(),an=new un,fn=an.produce;an.produceWithPatches.bind(an);an.setAutoFreeze.bind(an);an.setUseProxies.bind(an);an.applyPatches.bind(an);an.createDraft.bind(an);an.finishDraft.bind(an);

function i(o){var f=useState(o),i=f[1];return [f[0],useCallback(function(n){i("function"==typeof n?fn(n):n);},[])]}

var defaultUseResolveCallOptions = {
    autoFetch: true,
};
var _useResolveCall = function (call, initialData, params, options) {
    var isInitialized = useMoralis().isInitialized;
    var autoFetch = __assign(__assign({}, defaultUseResolveCallOptions), (options !== null && options !== void 0 ? options : {})).autoFetch;
    var _a = useState(false), isFetching = _a[0], setIsFetching = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = i(initialData), data = _c[0], setData = _c[1];
    var paramsRef = useRef(params);
    if (!react(paramsRef.current, params)) {
        paramsRef.current = params;
    }
    /**
     * Run the function
     */
    var fetch = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, throwOnError = _b.throwOnError, onComplete = _b.onComplete, onError = _b.onError, onSuccess = _b.onSuccess, fetchParams = _b.params;
        return __awaiter(void 0, void 0, void 0, function () {
            var combinedParams, results, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setIsFetching(true);
                        setError(null);
                        combinedParams = __assign(__assign({}, params), fetchParams);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, call(combinedParams)];
                    case 2:
                        results = _c.sent();
                        setData(results);
                        if (onSuccess) {
                            onSuccess(results);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        setData(initialData);
                        setError(error_1);
                        if (throwOnError) {
                            throw error_1;
                        }
                        if (onError) {
                            onError(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setIsFetching(false);
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [call, paramsRef.current]);
    var isLoading = isFetching &&
        data == null &&
        (Array.isArray(data) ? data.length === 0 : true);
    /**
     * Automatically fetch the call function
     */
    useEffect(function () {
        if (!isInitialized || !autoFetch) {
            return;
        }
        fetch();
    }, [fetch, isInitialized]);
    return {
        fetch: fetch,
        isFetching: isFetching,
        isLoading: isLoading,
        error: error,
        data: data,
        setData: setData,
    };
};

var useMoralisCloudFunction = function (name, params, options) {
    var call = useCallback(function (callParams) {
        return Moralis.Cloud.run(name, callParams);
    }, [name]);
    return _useResolveCall(call, null, params, options);
};

var useMoralisFile = function () {
    var _a = useState(null), error = _a[0], setError = _a[1];
    var _b = useState(false), isUploading = _b[0], setIsUploading = _b[1];
    var _c = useState(null), moralisFile = _c[0], setMoralisFile = _c[1];
    /**
     * Save the provided file
     */
    var saveFile = useCallback(function (name, file, _a) {
        var _b = _a === void 0 ? {} : _a, type = _b.type, metadata = _b.metadata, tags = _b.tags, saveIPFS = _b.saveIPFS, throwOnError = _b.throwOnError, onComplete = _b.onComplete, onError = _b.onError, onSuccess = _b.onSuccess;
        return __awaiter(void 0, void 0, void 0, function () {
            var moralisFile_1, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, 6, 7]);
                        setIsUploading(true);
                        setError(null);
                        moralisFile_1 = new Moralis.File(name, file, type, 
                        //@ts-ignore type is different than documentation (it should accept metadata and tags)
                        metadata, tags);
                        if (!saveIPFS) return [3 /*break*/, 2];
                        return [4 /*yield*/, moralisFile_1.saveIPFS()];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, moralisFile_1.save()];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        setMoralisFile(moralisFile_1);
                        if (onSuccess) {
                            onSuccess(moralisFile_1);
                        }
                        return [2 /*return*/, moralisFile_1];
                    case 5:
                        error_1 = _c.sent();
                        setError(error_1);
                        if (throwOnError) {
                            throw error_1;
                        }
                        if (onError) {
                            onError(error_1);
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        setIsUploading(false);
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }, []);
    return {
        error: error,
        saveFile: saveFile,
        isUploading: isUploading,
        moralisFile: moralisFile,
    };
};

var setMultipleDataToUser = function (data, user) {
    // We use the specified functions to set password, email, and username
    var password = data.password, email = data.email, username = data.username, restData = __rest(data, ["password", "email", "username"]);
    if (password !== undefined) {
        if (typeof password !== "string") {
            throw new ValidationError("password can only be a string type");
        }
        user.setPassword(password);
    }
    if (email !== undefined) {
        if (typeof email !== "string") {
            throw new ValidationError("email can only be a string type");
        }
        user.setEmail(email);
    }
    if (username !== undefined) {
        if (typeof username !== "string") {
            throw new ValidationError("username can only be a string type");
        }
        user.setUsername(username);
    }
    Object.entries(restData)
        .filter(function (_a) {
        var value = _a[1];
        return value !== undefined;
    })
        .forEach(function (_a) {
        var key = _a[0], value = _a[1];
        user.set(key, value);
    });
};

var AuthenticationState;
(function (AuthenticationState) {
    AuthenticationState["UNDEFINED"] = "undefined";
    AuthenticationState["UNAUTHENTICATED"] = "unauthenticated";
    AuthenticationState["AUTHENTICATED"] = "authenticated";
    AuthenticationState["AUTHENTICATING"] = "authenticating";
    AuthenticationState["LOGGING_OUT"] = "logging_out";
    AuthenticationState["ERROR"] = "error";
})(AuthenticationState || (AuthenticationState = {}));
var initialAuth = {
    state: AuthenticationState.UNDEFINED,
    error: null,
};
var defaultUseMoralisAuthOptions = {
    // We will override this right away, we just want to
    setUser: function () { },
};
/**
 * Hook that handles all authentication logic and returns the correct auth state
 * and its functions
 */
var _useMoralisAuth = function (options) {
    var onAccountChanged = __assign(__assign({}, defaultUseMoralisAuthOptions), options).onAccountChanged;
    var setUser = options.setUser;
    var _a = useState(initialAuth), auth = _a[0], setAuth = _a[1];
    var _b = useState(false), hasOnAccountChangeListener = _b[0], setHasOnAccountChangeListener = _b[1];
    /**
     * Authenticates the user by calling the Moralis.Web3.authenticate function
     * The auth state will update upon successful/error
     * For direct feedback, a callback can be provided
     */
    var authenticate = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, onComplete = _b.onComplete, onError = _b.onError, onSuccess = _b.onSuccess, throwOnError = _b.throwOnError, type = _b.type, provider = _b.provider, chainId = _b.chainId, signingMessage = _b.signingMessage;
        return __awaiter(void 0, void 0, void 0, function () {
            var user, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setAuth({
                            state: AuthenticationState.AUTHENTICATING,
                            error: null,
                        });
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Moralis.Web3.authenticate(__assign(__assign(__assign(__assign({}, (!!type && { type: type })), (!!provider && { provider: provider })), (!!chainId && { chainId: chainId })), (!!signingMessage && { signingMessage: signingMessage })))];
                    case 2:
                        user = _c.sent();
                        setUser(user);
                        setAuth({
                            state: AuthenticationState.AUTHENTICATED,
                            error: null,
                        });
                        if (onSuccess) {
                            onSuccess(user);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        setAuth({ state: AuthenticationState.ERROR, error: error_1 });
                        if (onError) {
                            onError(error_1);
                        }
                        if (throwOnError) {
                            throw error_1;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, []);
    /**
     * signup the user in with provided credentials
     */
    var signup = useCallback(function (username, password, email, otherFields, _a) {
        if (otherFields === void 0) { otherFields = {}; }
        var _b = _a === void 0 ? {} : _a, throwOnError = _b.throwOnError, onSuccess = _b.onSuccess, onError = _b.onError, onComplete = _b.onComplete;
        return __awaiter(void 0, void 0, void 0, function () {
            var newUser, user, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setAuth({
                            state: AuthenticationState.AUTHENTICATING,
                            error: null,
                        });
                        newUser = new Moralis.User();
                        setMultipleDataToUser(__assign({ username: username,
                            password: password,
                            email: email }, otherFields), newUser);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, newUser.signUp()];
                    case 2:
                        user = _c.sent();
                        setAuth({
                            state: AuthenticationState.AUTHENTICATED,
                            error: null,
                        });
                        setUser(user);
                        if (onSuccess) {
                            onSuccess(user);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _c.sent();
                        setAuth({ state: AuthenticationState.ERROR, error: error_2 });
                        if (throwOnError) {
                            throw error_2;
                        }
                        if (onError) {
                            onError(error_2);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, []);
    /**
     * Logs the user in with provided credentials
     */
    var login = useCallback(function (username, password, _a) {
        var _b = _a === void 0 ? {} : _a, usePost = _b.usePost, throwOnError = _b.throwOnError, onError = _b.onError, onSuccess = _b.onSuccess, onComplete = _b.onComplete;
        return __awaiter(void 0, void 0, void 0, function () {
            var user, error_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setAuth({
                            state: AuthenticationState.AUTHENTICATING,
                            error: null,
                        });
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Moralis.User.logIn(username, password, {
                                // @ts-ignore: missing types
                                usePost: usePost,
                            })];
                    case 2:
                        user = _c.sent();
                        setAuth({
                            state: AuthenticationState.AUTHENTICATED,
                            error: null,
                        });
                        setUser(user);
                        if (onSuccess) {
                            onSuccess(user);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _c.sent();
                        setAuth({ state: AuthenticationState.ERROR, error: error_3 });
                        if (throwOnError) {
                            throw error_3;
                        }
                        if (onError) {
                            onError(error_3);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, []);
    /**
     * Logs the user out via Moralis.User.logOut and handles the internal state
     */
    var logout = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, throwOnError = _b.throwOnError, onError = _b.onError, onSuccess = _b.onSuccess, onComplete = _b.onComplete;
        return __awaiter(void 0, void 0, void 0, function () {
            var error_4;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setAuth({
                            state: AuthenticationState.AUTHENTICATING,
                            error: null,
                        });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Moralis.User.logOut()];
                    case 2:
                        _d.sent();
                        setAuth({ state: AuthenticationState.UNAUTHENTICATED, error: null });
                        setUser(null);
                        if (onSuccess) {
                            onSuccess();
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_4 = _d.sent();
                        setAuth({ state: AuthenticationState.ERROR, error: error_4 });
                        // Set user to the currentUser (we don't know if the logout was successfull)
                        setUser((_c = Moralis.User.current()) !== null && _c !== void 0 ? _c : null);
                        if (throwOnError) {
                            throw error_4;
                        }
                        if (onError) {
                            onError(error_4);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, []);
    /**
     * Update the auth state if the user already ahs authenticated before
     */
    useEffect(function () {
        try {
            var currentUser = Moralis.User.current();
            if (currentUser) {
                setAuth({
                    state: AuthenticationState.AUTHENTICATED,
                    error: null,
                });
                setUser(currentUser);
            }
            else {
                throw new Error("Let it catch");
            }
        }
        catch (error) {
            setAuth({
                state: AuthenticationState.UNAUTHENTICATED,
                error: null,
            });
            setUser(null);
        }
    }, []);
    /**
     * Assign web3 Listener to handle change of accounts
     *
     * Important!: these eventListeners cannot be cleaned up, so don't reassign it
     * See https://github.com/MetaMask/metamask-extension/issues/10873
     *
     * The drawback of this is that we cannot update these function via a React state
     * // TODO: find a way to work around this
     */
    useEffect(function () {
        if (hasOnAccountChangeListener) {
            return;
        }
        if (!window) {
            console.warn("No window object found");
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var ethereum = window.ethereum;
        if (!ethereum) {
            console.warn("No window.ethereum found");
            return;
        }
        ethereum.on("accountsChanged", function (accounts) { return __awaiter(void 0, void 0, void 0, function () {
            var account;
            return __generator(this, function (_a) {
                account = accounts[0];
                if (onAccountChanged) {
                    onAccountChanged(account);
                }
                return [2 /*return*/];
            });
        }); });
        setHasOnAccountChangeListener(true);
    }, [hasOnAccountChangeListener]);
    var isAuthenticated = auth.state === AuthenticationState.AUTHENTICATED;
    var isUnauthenticated = auth.state === AuthenticationState.UNAUTHENTICATED;
    var isAuthenticating = auth.state === AuthenticationState.AUTHENTICATING;
    var hasAuthError = auth.state === AuthenticationState.ERROR;
    var isLoggingOut = auth.state === AuthenticationState.LOGGING_OUT;
    var isAuthUndefined = auth.state === AuthenticationState.UNDEFINED;
    return {
        auth: auth,
        authenticate: authenticate,
        signup: signup,
        login: login,
        logout: logout,
        authError: auth.error,
        isAuthenticated: isAuthenticated,
        isUnauthenticated: isUnauthenticated,
        isAuthenticating: isAuthenticating,
        hasAuthError: hasAuthError,
        isLoggingOut: isLoggingOut,
        isAuthUndefined: isAuthUndefined,
    };
};

/**
 * Hook that handles the initialization of Moralis
 */
var _useMoralisInit = function (_a) {
    var appId = _a.appId, serverUrl = _a.serverUrl, jsKey = _a.jsKey, dangerouslyUseOfMasterKey = _a.dangerouslyUseOfMasterKey;
    var _b = useState(false), isInitialized = _b[0], setIsInitialized = _b[1];
    useEffect(function () {
        if (!appId) {
            throw new ReactMoralisError("Provide a \"appId\" provided to <MoralisProvider>");
        }
        if (!serverUrl) {
            throw new ReactMoralisError("Provide a \"serverUrl\" provided to <MoralisProvider>");
        }
        if (isInitialized) {
            return;
        }
        Moralis.initialize(appId, jsKey, dangerouslyUseOfMasterKey);
        Moralis.serverURL = serverUrl;
        setIsInitialized(true);
    }, [appId, serverUrl, isInitialized]);
    return { isInitialized: isInitialized };
};

var _useMoralisUser = function () {
    var _a = useState(null), user = _a[0], setUser = _a[1];
    var _b = useState(false), isUpdating = _b[0], setIsUpdating = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    /**
     * Function to change the userData, any changes made via this function will sync to Moralis AND the local state
     */
    var setUserData = useCallback(function (data, _a) {
        var _b = _a === void 0 ? {} : _a, throwOnError = _b.throwOnError, onComplete = _b.onComplete, onError = _b.onError, onSuccess = _b.onSuccess;
        return __awaiter(void 0, void 0, void 0, function () {
            var userHasLocallyUpdated, currentUser, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!user) {
                            throw new NotAuthenticatedError("User needs to be authenticated before setting new data");
                        }
                        setIsUpdating(true);
                        setError(null);
                        userHasLocallyUpdated = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        setMultipleDataToUser(data, user);
                        userHasLocallyUpdated = true;
                        return [4 /*yield*/, user.save()];
                    case 2:
                        _c.sent();
                        currentUser = Moralis.User.current();
                        if (!currentUser) {
                            throw new ReactMoralisError("No user data found after save");
                        }
                        setUser(currentUser);
                        if (onSuccess) {
                            onSuccess(user);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        if (userHasLocallyUpdated) {
                            user.revert();
                        }
                        setError(error_1);
                        if (throwOnError) {
                            throw error_1;
                        }
                        if (onError) {
                            onError(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setIsUpdating(false);
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [user]);
    /**
     * Function to refetch the user and update the user object
     */
    var refetchUserData = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, throwOnError = _b.throwOnError, onComplete = _b.onComplete, onError = _b.onError, onSuccess = _b.onSuccess;
        return __awaiter(void 0, void 0, void 0, function () {
            var newUserData, error_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!user) {
                            throw new NotAuthenticatedError("User needs to be authenticated before refetching");
                        }
                        setIsUpdating(true);
                        setError(null);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, user.fetch()];
                    case 2:
                        newUserData = _c.sent();
                        if (!newUserData) {
                            throw new ReactMoralisError("No user data found after refetch");
                        }
                        setUser(newUserData);
                        if (onSuccess) {
                            onSuccess(newUserData);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _c.sent();
                        setError(error_2);
                        if (throwOnError) {
                            throw error_2;
                        }
                        if (onError) {
                            onError(error_2);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setIsUpdating(false);
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [user]);
    return {
        setUserData: setUserData,
        setUser: setUser,
        refetchUserData: refetchUserData,
        user: user,
        _setUser: setUser,
        isUserUpdating: isUpdating,
        userError: error,
    };
};

/**
 * Handles enabling of web3 and providing it, as soon as the user is authenticated
 */
var _useMoralisWeb3 = function (isAuthenticated) {
    var _a = useState(new Moralis.Web3()), web3 = _a[0], setWeb3 = _a[1];
    var _b = useState(false), isWeb3Enabled = _b[0], setIsWeb3Enabled = _b[1];
    var _c = useState(null), web3EnableError = _c[0], setEnableWeb3Error = _c[1];
    var _d = useState(false), isWeb3EnableLoading = _d[0], setIsWeb3EnableLoading = _d[1];
    /**
     * Enable web3 with the browsers web3Provider (only available when a user has been authenticated)
     */
    var enableWeb3 = useCallback(function (_a) {
        var _b = _a === void 0 ? {} : _a, throwOnError = _b.throwOnError, onComplete = _b.onComplete, onError = _b.onError, onSuccess = _b.onSuccess, provider = _b.provider, chainId = _b.chainId;
        return __awaiter(void 0, void 0, void 0, function () {
            var currentWeb3, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setIsWeb3EnableLoading(true);
                        setEnableWeb3Error(null);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, Moralis.Web3.enable(__assign(__assign({}, (!!provider && { provider: provider })), (!!chainId && { chainId: chainId })))];
                    case 2:
                        currentWeb3 = _c.sent();
                        setWeb3(currentWeb3);
                        setIsWeb3Enabled(true);
                        if (onSuccess) {
                            onSuccess(currentWeb3);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _c.sent();
                        setEnableWeb3Error(error_1);
                        if (throwOnError) {
                            throw error_1;
                        }
                        if (onError) {
                            onError(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setIsWeb3EnableLoading(false);
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, []);
    return {
        enableWeb3: enableWeb3,
        web3: web3,
        isWeb3Enabled: isWeb3Enabled,
        web3EnableError: web3EnableError,
        isWeb3EnableLoading: isWeb3EnableLoading,
    };
};

var MoralisProvider = function (_a) {
    var children = _a.children, appId = _a.appId, jsKey = _a.jsKey, dangerouslyUseOfMasterKey = _a.dangerouslyUseOfMasterKey, serverUrl = _a.serverUrl, _b = _a.options, _c = _b === void 0 ? {} : _b, onAccountChanged = _c.onAccountChanged;
    var moralisInit = _useMoralisInit({
        appId: appId,
        serverUrl: serverUrl,
        jsKey: jsKey,
        dangerouslyUseOfMasterKey: dangerouslyUseOfMasterKey,
    });
    var _d = _useMoralisUser(), setUser = _d.setUser, moralisUser = __rest(_d, ["setUser"]);
    var moralisAuth = _useMoralisAuth({ onAccountChanged: onAccountChanged, setUser: setUser });
    var moralisWeb3 = _useMoralisWeb3();
    return (jsx(MoralisContext.Provider, __assign({ value: __assign(__assign(__assign(__assign({ Moralis: Moralis }, moralisInit), moralisAuth), moralisUser), moralisWeb3) }, { children: children }), void 0));
};

/**
 * Wrapper hook for using with queries.
 * It accepts a valid query (string or Moralis.Object),
 * and a mapping to filter the query
 *
 * It will only update when the provided dependencies change
 */
var _useSafeUpdatedQuery = function (nameOrObject, queryMap, dependencies, isInitialized) {
    if (queryMap === void 0) { queryMap = function (q) { return q; }; }
    if (dependencies === void 0) { dependencies = []; }
    // Cached version of the queruMap to prevent unwantedUpdates
    var currentQueryMap = useMemo(function () {
        return queryMap;
    }, dependencies);
    var currentNameOrObject = useMemo(function () {
        return nameOrObject;
    }, dependencies);
    var query = useMemo(function () {
        var q = new Moralis.Query(
        // Explicit cast to any to prevent ts-error, because Moralis.Query should accept a Moralis.object
        currentNameOrObject);
        return currentQueryMap(q);
    }, [isInitialized, currentNameOrObject, currentQueryMap]);
    return query;
};

var _useSubscriptionListener = function (_a) {
    var name = _a.name, handler = _a.handler, enable = _a.enable, subscription = _a.subscription;
    var isInitialized = useMoralis().isInitialized;
    /**
     * Assign listeners subscription
     */
    useEffect(function () {
        if (!enable || !isInitialized || !subscription || !handler) {
            return;
        }
        subscription.on(name, handler);
        return function () {
            if (subscription) {
                subscription.off(name, handler);
            }
        };
    }, [isInitialized, handler, enable, name]);
};

var defaultUseSubscriptionQueryOptions = {
    enabled: true,
};
var useMoralisSubscription = function (nameOrObject, queryMap, dependencies, options) {
    var _a, _b, _c, _d, _e, _f;
    if (queryMap === void 0) { queryMap = function (q) { return q; }; }
    if (dependencies === void 0) { dependencies = []; }
    if (options === void 0) { options = {}; }
    var _g = __assign(__assign({}, defaultUseSubscriptionQueryOptions), options), enabled = _g.enabled, onCreate = _g.onCreate, onDelete = _g.onDelete, onEnter = _g.onEnter, onLeave = _g.onLeave, onUpdate = _g.onUpdate;
    var moralisContext = useContext(MoralisContext);
    var isInitialized = (_a = moralisContext === null || moralisContext === void 0 ? void 0 : moralisContext.isInitialized) !== null && _a !== void 0 ? _a : false;
    var subscriptionRef = useRef();
    var _h = useState(false), isReady = _h[0], setIsReady = _h[1];
    var query = _useSafeUpdatedQuery(nameOrObject, queryMap, dependencies, isInitialized);
    /**
     * Subscribe (and cleanup) to this query
     */
    useEffect(function () {
        setIsReady(false);
        if (!enabled || !isInitialized) {
            return;
        }
        query.subscribe().then(function (sub) {
            subscriptionRef.current = sub;
            setIsReady(true);
        });
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [enabled, isInitialized, query]);
    _useSubscriptionListener({
        name: "create",
        handler: onCreate,
        subscription: subscriptionRef.current,
        enable: (_b = (enabled && isReady)) !== null && _b !== void 0 ? _b : false,
    });
    _useSubscriptionListener({
        name: "update",
        handler: onUpdate,
        subscription: subscriptionRef.current,
        enable: (_c = (enabled && isReady)) !== null && _c !== void 0 ? _c : false,
    });
    _useSubscriptionListener({
        name: "enter",
        handler: onEnter,
        subscription: subscriptionRef.current,
        enable: (_d = (enabled && isReady)) !== null && _d !== void 0 ? _d : false,
    });
    _useSubscriptionListener({
        name: "leave",
        handler: onLeave,
        subscription: subscriptionRef.current,
        enable: (_e = (enabled && isReady)) !== null && _e !== void 0 ? _e : false,
    });
    _useSubscriptionListener({
        name: "delete",
        handler: onDelete,
        subscription: subscriptionRef.current,
        enable: (_f = (enabled && isReady)) !== null && _f !== void 0 ? _f : false,
    });
};

var defaultUseMoralisQueryOptions = {
    autoFetch: true,
    live: false,
    onLiveEnter: function (entity, all) { return __spreadArray(__spreadArray([], all), [entity]); },
    onLiveCreate: function (entity, all) { return __spreadArray(__spreadArray([], all), [entity]); },
    onLiveDelete: function (entity, all) { return all.filter(function (e) { return e.id !== entity.id; }); },
    onLiveLeave: function (entity, all) { return all.filter(function (e) { return e.id !== entity.id; }); },
    onLiveUpdate: function (entity, all) {
        return all.map(function (e) { return (e.id === entity.id ? entity : e); });
    },
};
var useMoralisQuery = function (nameOrObject, queryMap, dependencies, options) {
    if (queryMap === void 0) { queryMap = function (q) { return q; }; }
    if (dependencies === void 0) { dependencies = []; }
    if (options === void 0) { options = {}; }
    var isInitialized = useMoralis().isInitialized;
    var _a = __assign(__assign({}, defaultUseMoralisQueryOptions), options), live = _a.live, onLiveCreate = _a.onLiveCreate, onLiveDelete = _a.onLiveDelete, onLiveEnter = _a.onLiveEnter, onLiveLeave = _a.onLiveLeave, onLiveUpdate = _a.onLiveUpdate;
    var query = _useSafeUpdatedQuery(nameOrObject, queryMap, dependencies, isInitialized);
    var call = useCallback(function () { return query.find(); }, [query]);
    var _b = _useResolveCall(call, [], undefined, options), data = _b.data, error = _b.error, fetch = _b.fetch, isFetching = _b.isFetching, isLoading = _b.isLoading, setData = _b.setData;
    var handleOnCreate = useCallback(function (entity) {
        if (onLiveCreate) {
            setData(function (data) { return onLiveCreate(entity, data); });
        }
    }, [onLiveCreate]);
    var handleOnEnter = useCallback(function (entity) {
        if (onLiveEnter) {
            setData(function (data) { return onLiveEnter(entity, data); });
        }
    }, [onLiveEnter]);
    var handleOnUpdate = useCallback(function (entity) {
        if (onLiveUpdate) {
            setData(function (data) { return onLiveUpdate(entity, data); });
        }
    }, [onLiveUpdate]);
    var handleOnDelete = useCallback(function (entity) {
        if (onLiveDelete) {
            setData(function (data) { return onLiveDelete(entity, data); });
        }
    }, [onLiveDelete]);
    var handleOnLeave = useCallback(function (entity) {
        if (onLiveLeave) {
            setData(function (data) { return onLiveLeave(entity, data); });
        }
    }, [onLiveLeave]);
    // Update the data upon updated
    useMoralisSubscription(nameOrObject, queryMap, dependencies, {
        enabled: live,
        onCreate: handleOnCreate,
        onEnter: handleOnEnter,
        onUpdate: handleOnUpdate,
        onDelete: handleOnDelete,
        onLeave: handleOnLeave,
    });
    return { fetch: fetch, isFetching: isFetching, isLoading: isLoading, error: error, data: data };
};

/**
 * A hook for making/saving new Moralis Objects
 */
var useNewMoralisObject = function (objectClassName) {
    var _a = useState(false), isSaving = _a[0], setIsSaving = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(null), object = _c[0], setObject = _c[1];
    /**
     * Save function to save data to the object
     */
    var save = useCallback(function (data, _a) {
        if (data === void 0) { data = {}; }
        var _b = _a === void 0 ? {} : _a, cascadeSave = _b.cascadeSave, throwOnError = _b.throwOnError, context = _b.context, onSuccess = _b.onSuccess, onComplete = _b.onComplete, onError = _b.onError;
        return __awaiter(void 0, void 0, void 0, function () {
            var Object_1, object_1, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        setIsSaving(true);
                        setError(null);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        Object_1 = Moralis.Object.extend(objectClassName);
                        object_1 = new Object_1();
                        // TODO: support saving of nested objects more easy?
                        // @ts-ignore (context does not exist in the save options type)
                        return [4 /*yield*/, object_1.save(data, { cascadeSave: cascadeSave, context: context })];
                    case 2:
                        // TODO: support saving of nested objects more easy?
                        // @ts-ignore (context does not exist in the save options type)
                        _c.sent();
                        setObject(object_1);
                        if (onSuccess) {
                            onSuccess(object_1);
                        }
                        return [2 /*return*/, object_1];
                    case 3:
                        error_1 = _c.sent();
                        setError(error_1);
                        if (throwOnError) {
                            throw error_1;
                        }
                        if (onError) {
                            onError(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setIsSaving(false);
                        if (onComplete) {
                            onComplete();
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, [objectClassName]);
    return {
        isSaving: isSaving,
        object: object,
        error: error,
        save: save,
    };
};

var useMoralisWeb3ApiCall = function (call, params, options) {
    var result = _useResolveCall(call, null, params, options);
    return result;
};
var useMoralisWeb3Api = function () {
    return __assign({ Web3API: Moralis.Web3API }, Moralis.Web3API);
};

var white = "#fff";
var brand = "#b7e803";
var PoweredByColour = function (_a) {
    var style = _a.style;
    return (jsxs("svg", __assign({ style: style, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 192 45" }, { children: [jsx("path", { style: { fill: brand }, d: "M0 22.5A21.51 21.51 0 0121.5 1h149a21.5 21.5 0 010 43h-149A21.51 21.51 0 010 22.5z" }, void 0),
            jsx("circle", { cx: "25.5", cy: "22.5", r: "17.5" }, void 0),
            jsx("path", { style: { fill: white }, d: "M36.6 30.9l-.12.16s.08-.06.12-.16zM40 20.94A8.23 8.23 0 0031.7 13a8.38 8.38 0 00-5.7 2.25A8.3 8.3 0 0012 21v.06a17.82 17.82 0 002.41 8.48A23.4 23.4 0 0016 32.09c.22.3.41.54.55.71l.17.21.05.06a2.67 2.67 0 003.75.25 2.62 2.62 0 00.25-3.71l-.1-.11c-.08-.12-.22-.29-.39-.52A17.51 17.51 0 0119.07 27a12.74 12.74 0 01-1.76-5.9 3 3 0 016 0 2.72 2.72 0 00.3 1.14 2.66 2.66 0 005.13-.91V21a3 3 0 016 0 11.6 11.6 0 01-1.2 4.74c-.32.65-.62 1.18-.85 1.55-.11.19-.2.32-.26.41l-.06.08a2.66 2.66 0 012.08-1A2.63 2.63 0 0137 29.49a2.55 2.55 0 01-.43 1.41.1.1 0 000-.05l.12-.17c.1-.14.23-.35.39-.6A21.81 21.81 0 0038.31 28 16.56 16.56 0 0040 21v-.06z" }, void 0),
            jsx("path", { style: { fill: brand }, d: "M34.36 26.89a2.71 2.71 0 00-2.08 1 2.56 2.56 0 00-.57 1.62 2.63 2.63 0 002.65 2.6 2.69 2.69 0 002.11-1l.12-.16a2.6 2.6 0 00-2.23-4z" }, void 0),
            jsx("path", { d: "M55.61 21.43a2.4 2.4 0 01-.89 2 4 4 0 01-2.54.7h-1v3.37h-1v-8.57h2.22c2.14 0 3.21.84 3.21 2.5zm-4.44 1.84h.9a3.41 3.41 0 001.93-.42 1.6 1.6 0 00.59-1.37 1.49 1.49 0 00-.59-1.27 2.88 2.88 0 00-1.73-.42h-1.1zm11.64 1a3.55 3.55 0 01-.8 2.46 2.79 2.79 0 01-2.18.88 2.87 2.87 0 01-1.53-.41 2.59 2.59 0 01-1-1.16 4.05 4.05 0 01-.37-1.77 3.54 3.54 0 01.79-2.44 2.75 2.75 0 012.15-.83 2.71 2.71 0 012.14.9 3.51 3.51 0 01.8 2.38zm-4.9 0a3.12 3.12 0 00.49 1.88 2 2 0 002.9 0 3 3 0 00.5-1.88 3 3 0 00-.5-1.85 2 2 0 00-2.9 0 3 3 0 00-.49 1.86zm11.85 3.23l-1.18-3.77c-.07-.23-.21-.75-.41-1.57-.16.69-.29 1.21-.41 1.58L66.5 27.5h-1.13l-1.75-6.42h1c.41 1.61.73 2.84.94 3.68a15 15 0 01.44 1.71c0-.22.11-.51.21-.86s.18-.64.25-.85l1.18-3.68h1l1.15 3.68a12.91 12.91 0 01.45 1.7c0-.14.06-.36.13-.65s.48-1.87 1.22-4.73h1l-1.68 6.42zm6.81.12a3 3 0 01-2.25-.87 3.35 3.35 0 01-.82-2.41 3.69 3.69 0 01.76-2.46 2.55 2.55 0 012.06-.88 2.43 2.43 0 011.91.8 3.07 3.07 0 01.7 2.09v.61h-4.42a2.55 2.55 0 00.56 1.72 2 2 0 001.53.59 5.15 5.15 0 002.05-.44v.87a4.77 4.77 0 01-1 .32 5.85 5.85 0 01-1.08.06zm-.26-5.85a1.59 1.59 0 00-1.24.51 2.28 2.28 0 00-.54 1.39h3.36a2.13 2.13 0 00-.41-1.4 1.45 1.45 0 00-1.17-.5zm7.21-.77a3.61 3.61 0 01.77.07l-.13.9a4 4 0 00-.71-.08 1.71 1.71 0 00-1.33.63 2.3 2.3 0 00-.55 1.57v3.41h-1v-6.42h.81l.11 1.19a2.72 2.72 0 01.86-1 1.88 1.88 0 011.17-.27zm4.69 6.66a3 3 0 01-2.21-.91 3.35 3.35 0 01-.82-2.41 3.69 3.69 0 01.76-2.46A2.53 2.53 0 0188 21a2.4 2.4 0 011.91.8 3 3 0 01.71 2.09v.61h-4.48a2.55 2.55 0 00.57 1.72 2 2 0 001.53.59 5.15 5.15 0 002.05-.44v.87a4.65 4.65 0 01-1 .32 5.66 5.66 0 01-1.08.06zm-.27-5.85a1.57 1.57 0 00-1.23.51 2.28 2.28 0 00-.54 1.39h3.35a2.07 2.07 0 00-.41-1.4 1.43 1.43 0 00-1.17-.54zm8.66 4.87a2.29 2.29 0 01-2 1 2.4 2.4 0 01-2-.86 3.78 3.78 0 01-.7-2.45 3.86 3.86 0 01.71-2.47 2.6 2.6 0 014 .07h.07V18.38h1v9.12h-.79zm-1.94.16a1.77 1.77 0 001.44-.54 2.72 2.72 0 00.45-1.75v-.2a3.18 3.18 0 00-.46-1.95 1.7 1.7 0 00-1.44-.59 1.52 1.52 0 00-1.32.67 3.33 3.33 0 00-.45 1.88 3.19 3.19 0 00.45 1.86 1.54 1.54 0 001.33.58zm11-5.83a2.38 2.38 0 012 .87 3.75 3.75 0 01.7 2.44 3.81 3.81 0 01-.71 2.46 2.35 2.35 0 01-2 .88 2.88 2.88 0 01-1.15-.23 2.17 2.17 0 01-.87-.72h-.07l-.21.83h-.69v-9.16h1v2.22c0 .49 0 .94-.05 1.33h.05a2.3 2.3 0 012.04-.93zm-.15.82a1.69 1.69 0 00-1.43.57 3.23 3.23 0 00-.44 1.92 3.22 3.22 0 00.45 1.94 1.71 1.71 0 001.45.58 1.47 1.47 0 001.33-.65 3.31 3.31 0 00.44-1.88 3.19 3.19 0 00-.44-1.87 1.54 1.54 0 00-1.32-.65zm3.5-.71h1l1.41 3.66a14.72 14.72 0 01.57 1.81h.05c0-.2.15-.54.31-1s.7-2 1.6-4.45h1l-2.76 7.31a3.64 3.64 0 01-1 1.54 2 2 0 01-1.34.45 3.71 3.71 0 01-.88-.1v-.84a3.14 3.14 0 00.72.07 1.48 1.48 0 001.43-1.12l.36-.91zm13.89 6.38l-2.06-6.72c.07 1.37.11 2.28.11 2.74v4h-1.62v-8.59h2.47l2 6.55 2.2-6.55h2.48v8.57h-1.7v-4.05-.67c0-.25 0-.91.08-2l-2.21 6.71zm9-3.29a2.76 2.76 0 00.32 1.47 1.33 1.33 0 002.07 0 2.79 2.79 0 00.31-1.48 2.73 2.73 0 00-.31-1.46 1.17 1.17 0 00-1-.48 1.14 1.14 0 00-1 .48 2.7 2.7 0 00-.41 1.47zm4.53 0a3.52 3.52 0 01-.84 2.5 3.05 3.05 0 01-2.35.91 3.36 3.36 0 01-1.67-.41 2.75 2.75 0 01-1.1-1.19 4 4 0 01-.39-1.81 3.47 3.47 0 01.84-2.49 3 3 0 012.35-.89 3.26 3.26 0 011.67.41 2.65 2.65 0 011.1 1.17 3.94 3.94 0 01.37 1.8zm5.13-3.38a2.62 2.62 0 01.61.05l-.17 1.67a2.58 2.58 0 00-.53-.05 1.86 1.86 0 00-1.33.44 1.58 1.58 0 00-.48 1.23v3.33h-1.78V21h1.35l.26 1.1h.09a2.39 2.39 0 01.82-.88 2 2 0 011.14-.39zm6 6.67l-.35-.89h-.05a2.65 2.65 0 01-.93.79 3.09 3.09 0 01-1.24.22 2 2 0 01-1.49-.54 2.08 2.08 0 01-.54-1.54 1.73 1.73 0 01.73-1.53 4.19 4.19 0 012.2-.55h1.14v-.29a.89.89 0 00-1-1 4.79 4.79 0 00-1.85.47l-.59-1.2a5.29 5.29 0 012.51-.6 3.14 3.14 0 012 .58 2.1 2.1 0 01.7 1.74v4.34zm-.53-3h-.69a2.17 2.17 0 00-1.16.28.86.86 0 00-.38.78c0 .51.28.76.86.76a1.34 1.34 0 001-.36A1.25 1.25 0 00147 25zm5.41 3h-1.79v-9.12h1.79zm1.8-8.24c0-.59.33-.88 1-.88s1 .29 1 .88a.89.89 0 01-.25.65 1 1 0 01-.73.22c-.75 0-1.08-.29-1.08-.87zM156 27.5h-1.78V21H156zm6.46-1.95a1.8 1.8 0 01-.71 1.54 3.44 3.44 0 01-2.09.53 7.06 7.06 0 01-1.22-.1 4.66 4.66 0 01-.94-.28v-1.48a5.44 5.44 0 001.12.39 4.35 4.35 0 001.1.16c.65 0 1-.19 1-.56a.44.44 0 00-.13-.34 1.63 1.63 0 00-.44-.3c-.21-.11-.49-.24-.85-.39a5.42 5.42 0 01-1.11-.59 1.62 1.62 0 01-.51-.61 2.08 2.08 0 01-.16-.87 1.53 1.53 0 01.67-1.34 3.28 3.28 0 011.92-.48 5.54 5.54 0 012.31.51l-.54 1.29c-.33-.14-.64-.25-.92-.34a2.94 2.94 0 00-.88-.14c-.52 0-.79.14-.79.43a.5.5 0 00.25.41 7.16 7.16 0 001.12.53 4.79 4.79 0 011.13.58 1.65 1.65 0 01.53.62 1.92 1.92 0 01.18.83zm1.14 1.11a1 1 0 01.26-.74 1.07 1.07 0 01.77-.25 1 1 0 01.75.25 1 1 0 01.27.74 1 1 0 01-.27.74 1.23 1.23 0 01-1.51 0 1 1 0 01-.23-.74zm3.6-7.4c0-.59.32-.88 1-.88s1 .29 1 .88a.88.88 0 01-.24.65 1.06 1.06 0 01-.73.22c-.67 0-.99-.29-.99-.87zm1.86 8.24h-1.79V21h1.79zm3.3-3.29a2.76 2.76 0 00.32 1.47 1.13 1.13 0 001 .5 1.12 1.12 0 001-.49 2.79 2.79 0 00.31-1.48 2.73 2.73 0 00-.31-1.46 1.15 1.15 0 00-1-.48 1.14 1.14 0 00-1 .48 2.7 2.7 0 00-.28 1.46zm4.53 0a3.52 3.52 0 01-.84 2.5 3 3 0 01-2.35.91 3.32 3.32 0 01-1.66-.41A2.84 2.84 0 01171 26a4 4 0 01-.39-1.81 3.47 3.47 0 01.84-2.49 3 3 0 012.35-.89 3.26 3.26 0 011.67.41 2.73 2.73 0 011.11 1.17 4.08 4.08 0 01.35 1.82z" }, void 0)] }), void 0));
};
var PoweredByLight = function (_a) {
    var style = _a.style;
    return (jsxs("svg", __assign({ style: style, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 192 45" }, { children: [jsx("path", { style: { fill: white }, d: "M1,22.5A21.51,21.51,0,0,1,22.5,1h147a21.5,21.5,0,0,1,0,43H22.5A21.51,21.51,0,0,1,1,22.5Z" }, void 0),
            jsx("path", { d: "M37.6,30.9h0l-.12.16S37.56,31,37.6,30.9Z" }, void 0),
            jsx("path", { d: "M41,20.94A8.23,8.23,0,0,0,32.7,13,8.38,8.38,0,0,0,27,15.25,8.3,8.3,0,0,0,13,21v.06a17.79,17.79,0,0,0,2.41,8.48A22.43,22.43,0,0,0,17,32.09c.22.3.41.54.55.71l.17.21.05.06,0,0h0a2.67,2.67,0,0,0,3.75.25,2.62,2.62,0,0,0,.25-3.71h0l0,0-.1-.11L21.31,29A17.51,17.51,0,0,1,20.07,27a12.74,12.74,0,0,1-1.76-5.9,3,3,0,0,1,6,0,2.72,2.72,0,0,0,.3,1.14,2.66,2.66,0,0,0,5.13-.91V21a3,3,0,0,1,6,0,11.6,11.6,0,0,1-1.2,4.74c-.32.65-.62,1.18-.85,1.55-.11.19-.2.32-.26.41l-.06.08h0l0,0a2.66,2.66,0,0,1,2.08-1A2.63,2.63,0,0,1,38,29.49a2.55,2.55,0,0,1-.43,1.41h0s0,0,0,0a.1.1,0,0,0,0-.05l.12-.17c.1-.14.23-.35.39-.6A21.81,21.81,0,0,0,39.31,28,16.56,16.56,0,0,0,41,21v-.06Z" }, void 0),
            jsx("path", { style: { fill: brand }, d: "M35.36,26.89a2.71,2.71,0,0,0-2.08,1,2.56,2.56,0,0,0-.57,1.62,2.63,2.63,0,0,0,2.65,2.6,2.69,2.69,0,0,0,2.11-1l.12-.16a2.6,2.6,0,0,0-2.23-4Z" }, void 0),
            jsx("path", { d: "M54.61,21.43a2.4,2.4,0,0,1-.89,2,4,4,0,0,1-2.54.7h-1V27.5h-1V18.93H51.4C53.54,18.93,54.61,19.77,54.61,21.43Zm-4.44,1.85h.9A3.4,3.4,0,0,0,53,22.85a1.59,1.59,0,0,0,.59-1.37A1.49,1.49,0,0,0,53,20.21a2.88,2.88,0,0,0-1.73-.42H50.17Zm11.64,1a3.55,3.55,0,0,1-.8,2.46,2.79,2.79,0,0,1-2.18.88,2.87,2.87,0,0,1-1.53-.41,2.59,2.59,0,0,1-1-1.16,4.05,4.05,0,0,1-.37-1.77,3.54,3.54,0,0,1,.79-2.44A2.75,2.75,0,0,1,58.87,21a2.71,2.71,0,0,1,2.14.9A3.51,3.51,0,0,1,61.81,24.28Zm-4.9,0a3.12,3.12,0,0,0,.49,1.88,2,2,0,0,0,2.9,0,3,3,0,0,0,.5-1.88,3,3,0,0,0-.5-1.85,2,2,0,0,0-2.9,0A3,3,0,0,0,56.91,24.28ZM68.76,27.5l-1.18-3.77c-.07-.23-.21-.75-.41-1.57h0c-.16.69-.29,1.21-.41,1.58L65.5,27.5H64.37l-1.75-6.42h1c.41,1.61.73,2.84.94,3.68A15,15,0,0,1,65,26.47h0c0-.22.11-.51.21-.86s.18-.64.25-.85l1.18-3.68h1l1.15,3.68a12.91,12.91,0,0,1,.45,1.7h0c0-.14.06-.36.13-.65s.48-1.87,1.22-4.73h1L69.91,27.5Zm6.81.12a3,3,0,0,1-2.25-.87,3.35,3.35,0,0,1-.82-2.41,3.69,3.69,0,0,1,.76-2.46A2.55,2.55,0,0,1,75.32,21a2.43,2.43,0,0,1,1.91.8,3.07,3.07,0,0,1,.7,2.09v.61H73.51a2.55,2.55,0,0,0,.56,1.72,2,2,0,0,0,1.53.59,5.15,5.15,0,0,0,2.05-.44v.87a4.77,4.77,0,0,1-1,.32A5.85,5.85,0,0,1,75.57,27.62Zm-.26-5.84a1.58,1.58,0,0,0-1.24.5,2.28,2.28,0,0,0-.54,1.39h3.36a2.13,2.13,0,0,0-.41-1.4A1.45,1.45,0,0,0,75.31,21.78ZM82.52,21a3.61,3.61,0,0,1,.77.07l-.13.9a4,4,0,0,0-.71-.08,1.71,1.71,0,0,0-1.33.63,2.3,2.3,0,0,0-.55,1.57V27.5h-1V21.08h.81l.11,1.19h0a2.72,2.72,0,0,1,.86-1A1.88,1.88,0,0,1,82.52,21Zm4.69,6.66A3,3,0,0,1,85,26.75a3.35,3.35,0,0,1-.82-2.41,3.69,3.69,0,0,1,.76-2.46A2.53,2.53,0,0,1,87,21a2.4,2.4,0,0,1,1.91.8,3,3,0,0,1,.71,2.09v.61H85.14a2.55,2.55,0,0,0,.57,1.72,2,2,0,0,0,1.53.59,5.15,5.15,0,0,0,2.05-.44v.87a4.65,4.65,0,0,1-1,.32A5.66,5.66,0,0,1,87.21,27.62Zm-.27-5.84a1.56,1.56,0,0,0-1.23.5,2.28,2.28,0,0,0-.54,1.39h3.35a2.07,2.07,0,0,0-.41-1.4A1.42,1.42,0,0,0,86.94,21.78Zm8.66,4.86h0a2.29,2.29,0,0,1-2,1,2.4,2.4,0,0,1-2-.86,3.78,3.78,0,0,1-.7-2.45,3.86,3.86,0,0,1,.71-2.47,2.6,2.6,0,0,1,4,.07h.07l0-.46,0-.45V18.38h1V27.5h-.79Zm-1.94.16a1.77,1.77,0,0,0,1.44-.54,2.72,2.72,0,0,0,.45-1.75v-.2a3.18,3.18,0,0,0-.46-1.95,1.7,1.7,0,0,0-1.44-.58,1.51,1.51,0,0,0-1.32.66,3.33,3.33,0,0,0-.45,1.88,3.19,3.19,0,0,0,.45,1.86A1.54,1.54,0,0,0,93.66,26.8Zm11-5.83a2.38,2.38,0,0,1,2,.87,3.75,3.75,0,0,1,.7,2.44,3.81,3.81,0,0,1-.71,2.46,2.35,2.35,0,0,1-2,.88,2.88,2.88,0,0,1-1.15-.23,2.17,2.17,0,0,1-.87-.72h-.07l-.21.83h-.69V18.38h1V20.6c0,.49,0,.94-.05,1.33h.05A2.3,2.3,0,0,1,104.7,21Zm-.15.82a1.69,1.69,0,0,0-1.43.57,3.23,3.23,0,0,0-.44,1.92,3.22,3.22,0,0,0,.45,1.94,1.71,1.71,0,0,0,1.45.58,1.47,1.47,0,0,0,1.33-.65,3.31,3.31,0,0,0,.44-1.88,3.19,3.19,0,0,0-.44-1.87A1.54,1.54,0,0,0,104.55,21.79Zm3.5-.71h1l1.41,3.66a14.72,14.72,0,0,1,.57,1.81h.05c0-.2.15-.54.31-1s.7-2,1.6-4.45h1l-2.76,7.31a3.64,3.64,0,0,1-1,1.54,2,2,0,0,1-1.34.45,3.71,3.71,0,0,1-.88-.1V29.5a3.14,3.14,0,0,0,.72.07,1.48,1.48,0,0,0,1.43-1.12l.36-.91ZM121.9,27.5l-2.06-6.72h0c.07,1.37.11,2.28.11,2.74v4h-1.62V18.93h2.47l2,6.55h0L125,18.93h2.48V27.5h-1.7V23.45c0-.2,0-.42,0-.67s0-.91.08-2h0l-2.21,6.71Zm9-3.29a2.76,2.76,0,0,0,.32,1.47,1.33,1.33,0,0,0,2.07,0,2.79,2.79,0,0,0,.31-1.48,2.73,2.73,0,0,0-.31-1.46,1.17,1.17,0,0,0-1-.48,1.14,1.14,0,0,0-1,.48A2.7,2.7,0,0,0,130.88,24.21Zm4.53,0a3.52,3.52,0,0,1-.84,2.5,3.05,3.05,0,0,1-2.35.91,3.36,3.36,0,0,1-1.67-.41,2.75,2.75,0,0,1-1.1-1.19,4,4,0,0,1-.39-1.81,3.47,3.47,0,0,1,.84-2.49,3,3,0,0,1,2.35-.89,3.26,3.26,0,0,1,1.67.41,2.65,2.65,0,0,1,1.1,1.17A4,4,0,0,1,135.41,24.21Zm5.13-3.38a2.62,2.62,0,0,1,.61.05L141,22.55a2.58,2.58,0,0,0-.53-.05,1.86,1.86,0,0,0-1.33.44,1.58,1.58,0,0,0-.48,1.23V27.5h-1.78V21h1.35l.26,1.1h.09a2.39,2.39,0,0,1,.82-.88A2,2,0,0,1,140.54,20.83Zm6,6.67-.35-.89h-.05a2.65,2.65,0,0,1-.93.79,3.09,3.09,0,0,1-1.24.22,2,2,0,0,1-1.49-.54,2.08,2.08,0,0,1-.54-1.54,1.73,1.73,0,0,1,.73-1.53,4.19,4.19,0,0,1,2.2-.55l1.14,0v-.29a.89.89,0,0,0-1-1,4.79,4.79,0,0,0-1.85.47l-.59-1.2a5.29,5.29,0,0,1,2.51-.6,3.14,3.14,0,0,1,2,.58,2.1,2.1,0,0,1,.7,1.74V27.5Zm-.53-3-.69,0a2.17,2.17,0,0,0-1.16.28.86.86,0,0,0-.38.78c0,.51.28.76.86.76a1.34,1.34,0,0,0,1-.36A1.25,1.25,0,0,0,146,25Zm5.41,3h-1.79V18.38h1.79Zm1.8-8.24c0-.59.33-.88,1-.88s1,.29,1,.88a.89.89,0,0,1-.25.65,1,1,0,0,1-.73.22C153.51,20.13,153.18,19.84,153.18,19.26ZM155,27.5h-1.78V21H155Zm6.46-1.95a1.8,1.8,0,0,1-.71,1.54,3.44,3.44,0,0,1-2.09.53,7.06,7.06,0,0,1-1.22-.1,4.66,4.66,0,0,1-.94-.28V25.76a5.44,5.44,0,0,0,1.12.39,4.35,4.35,0,0,0,1.1.16c.65,0,1-.19,1-.56a.44.44,0,0,0-.13-.34,1.63,1.63,0,0,0-.44-.3c-.21-.11-.49-.24-.85-.39a5.42,5.42,0,0,1-1.11-.59,1.62,1.62,0,0,1-.51-.61,2.08,2.08,0,0,1-.16-.87,1.53,1.53,0,0,1,.67-1.34,3.28,3.28,0,0,1,1.92-.48,5.54,5.54,0,0,1,2.31.51l-.54,1.29c-.33-.14-.64-.25-.92-.34a2.94,2.94,0,0,0-.88-.14c-.52,0-.79.14-.79.43a.5.5,0,0,0,.25.41,7.16,7.16,0,0,0,1.12.53,4.79,4.79,0,0,1,1.13.58,1.73,1.73,0,0,1,.53.62A1.92,1.92,0,0,1,161.5,25.55Zm1.14,1.11a1,1,0,0,1,.26-.74,1.07,1.07,0,0,1,.77-.25,1,1,0,0,1,.75.25,1.14,1.14,0,0,1,0,1.47,1,1,0,0,1-.75.27,1.06,1.06,0,0,1-.76-.26A1,1,0,0,1,162.64,26.66Zm3.6-7.4c0-.59.32-.88,1-.88s1,.29,1,.88a.88.88,0,0,1-.24.65,1.06,1.06,0,0,1-.73.22C166.56,20.13,166.24,19.84,166.24,19.26Zm1.86,8.24h-1.79V21h1.79Zm3.3-3.29a2.76,2.76,0,0,0,.32,1.47,1.13,1.13,0,0,0,1,.5,1.12,1.12,0,0,0,1-.49,2.79,2.79,0,0,0,.31-1.48,2.73,2.73,0,0,0-.31-1.46,1.15,1.15,0,0,0-1-.48,1.14,1.14,0,0,0-1,.48A2.7,2.7,0,0,0,171.4,24.21Zm4.53,0a3.52,3.52,0,0,1-.84,2.5,3,3,0,0,1-2.35.91,3.32,3.32,0,0,1-1.66-.41A2.84,2.84,0,0,1,170,26a4,4,0,0,1-.39-1.81,3.47,3.47,0,0,1,.84-2.49,3,3,0,0,1,2.35-.89,3.26,3.26,0,0,1,1.67.41,2.73,2.73,0,0,1,1.11,1.17A4.11,4.11,0,0,1,175.93,24.21Z" }, void 0),
            jsx("path", { d: "M22.5,2h147V0H22.5Zm147,41H22.5v2h147Zm-147,0A20.5,20.5,0,0,1,2,22.5H0A22.5,22.5,0,0,0,22.5,45ZM190,22.5A20.5,20.5,0,0,1,169.5,43v2A22.5,22.5,0,0,0,192,22.5ZM169.5,2A20.5,20.5,0,0,1,190,22.5h2A22.5,22.5,0,0,0,169.5,0ZM22.5,0A22.5,22.5,0,0,0,0,22.5H2A20.5,20.5,0,0,1,22.5,2Z" }, void 0)] }), void 0));
};
var PoweredByDark = function (_a) {
    var style = _a.style;
    return (jsxs("svg", __assign({ style: style, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 192 45" }, { children: [jsx("path", { d: "M1,22.5A21.51,21.51,0,0,1,22.5,1h147a21.5,21.5,0,0,1,0,43H22.5A21.51,21.51,0,0,1,1,22.5Z" }, void 0),
            jsx("path", { style: { fill: white }, d: "M37.6,30.9h0l-.12.16S37.56,31,37.6,30.9Z" }, void 0),
            jsx("path", { style: { fill: white }, d: "M41,20.94A8.23,8.23,0,0,0,32.7,13,8.38,8.38,0,0,0,27,15.25,8.3,8.3,0,0,0,13,21v.06a17.82,17.82,0,0,0,2.41,8.48A22.43,22.43,0,0,0,17,32.09c.22.3.41.54.55.71l.17.21.05.06,0,0h0a2.67,2.67,0,0,0,3.75.25,2.62,2.62,0,0,0,.25-3.71h0l0,0-.1-.11L21.31,29A17.51,17.51,0,0,1,20.07,27a12.74,12.74,0,0,1-1.76-5.9,3,3,0,0,1,6,0,2.72,2.72,0,0,0,.3,1.14,2.66,2.66,0,0,0,5.13-.91V21a3,3,0,0,1,6,0,11.6,11.6,0,0,1-1.2,4.74c-.32.65-.62,1.18-.85,1.55-.11.19-.2.32-.26.41l-.06.08a0,0,0,0,0,0,0l0,0a2.66,2.66,0,0,1,2.08-1A2.63,2.63,0,0,1,38,29.49a2.55,2.55,0,0,1-.43,1.41h0s0,0,0,0a.1.1,0,0,0,0-.05l.12-.17c.1-.14.23-.35.39-.6A21.81,21.81,0,0,0,39.31,28,16.56,16.56,0,0,0,41,21v-.06Z" }, void 0),
            jsx("path", { style: { fill: brand }, d: "M35.36,26.89a2.71,2.71,0,0,0-2.08,1,2.56,2.56,0,0,0-.57,1.62,2.63,2.63,0,0,0,2.65,2.6,2.69,2.69,0,0,0,2.11-1l.12-.16a2.6,2.6,0,0,0-2.23-4Z" }, void 0),
            jsx("path", { style: { fill: white }, d: "M54.61,21.43a2.4,2.4,0,0,1-.89,2,4,4,0,0,1-2.54.7h-1V27.5h-1V18.93H51.4C53.54,18.93,54.61,19.77,54.61,21.43Zm-4.44,1.84h.9A3.41,3.41,0,0,0,53,22.85a1.6,1.6,0,0,0,.59-1.37A1.49,1.49,0,0,0,53,20.21a2.88,2.88,0,0,0-1.73-.42H50.17Zm11.64,1a3.55,3.55,0,0,1-.8,2.46,2.79,2.79,0,0,1-2.18.88,2.87,2.87,0,0,1-1.53-.41,2.59,2.59,0,0,1-1-1.16,4.05,4.05,0,0,1-.37-1.77,3.54,3.54,0,0,1,.79-2.44A2.75,2.75,0,0,1,58.87,21a2.71,2.71,0,0,1,2.14.9A3.51,3.51,0,0,1,61.81,24.28Zm-4.9,0a3.12,3.12,0,0,0,.49,1.88,2,2,0,0,0,2.9,0,3,3,0,0,0,.5-1.88,3,3,0,0,0-.5-1.85,2,2,0,0,0-2.9,0A3,3,0,0,0,56.91,24.28ZM68.76,27.5l-1.18-3.77c-.07-.23-.21-.75-.41-1.57h0c-.16.69-.29,1.21-.41,1.58L65.5,27.5H64.37l-1.75-6.42h1c.41,1.61.73,2.84.94,3.68A15,15,0,0,1,65,26.47h0c0-.22.11-.51.21-.86s.18-.64.25-.85l1.18-3.68h1l1.15,3.68a12.91,12.91,0,0,1,.45,1.7h0c0-.14.06-.36.13-.65s.48-1.87,1.22-4.73h1L69.91,27.5Zm6.81.12a3,3,0,0,1-2.25-.87,3.35,3.35,0,0,1-.82-2.41,3.69,3.69,0,0,1,.76-2.46A2.55,2.55,0,0,1,75.32,21a2.43,2.43,0,0,1,1.91.8,3.07,3.07,0,0,1,.7,2.09v.61H73.51a2.55,2.55,0,0,0,.56,1.72,2,2,0,0,0,1.53.59,5.15,5.15,0,0,0,2.05-.44v.87a4.77,4.77,0,0,1-1,.32A5.85,5.85,0,0,1,75.57,27.62Zm-.26-5.85a1.59,1.59,0,0,0-1.24.51,2.28,2.28,0,0,0-.54,1.39h3.36a2.13,2.13,0,0,0-.41-1.4A1.45,1.45,0,0,0,75.31,21.77ZM82.52,21a3.61,3.61,0,0,1,.77.07l-.13.9a4,4,0,0,0-.71-.08,1.71,1.71,0,0,0-1.33.63,2.3,2.3,0,0,0-.55,1.57V27.5h-1V21.08h.81l.11,1.19h0a2.72,2.72,0,0,1,.86-1A1.88,1.88,0,0,1,82.52,21Zm4.69,6.66A3,3,0,0,1,85,26.75a3.35,3.35,0,0,1-.82-2.41,3.69,3.69,0,0,1,.76-2.46A2.53,2.53,0,0,1,87,21a2.4,2.4,0,0,1,1.91.8,3,3,0,0,1,.71,2.09v.61H85.14a2.55,2.55,0,0,0,.57,1.72,2,2,0,0,0,1.53.59,5.15,5.15,0,0,0,2.05-.44v.87a4.65,4.65,0,0,1-1,.32A5.66,5.66,0,0,1,87.21,27.62Zm-.27-5.85a1.57,1.57,0,0,0-1.23.51,2.28,2.28,0,0,0-.54,1.39h3.35a2.07,2.07,0,0,0-.41-1.4A1.43,1.43,0,0,0,86.94,21.77Zm8.66,4.87h0a2.29,2.29,0,0,1-2,1,2.4,2.4,0,0,1-2-.86,3.78,3.78,0,0,1-.7-2.45,3.86,3.86,0,0,1,.71-2.47,2.6,2.6,0,0,1,4,.07h.07l0-.46,0-.45V18.38h1V27.5h-.79Zm-1.94.16a1.77,1.77,0,0,0,1.44-.54,2.72,2.72,0,0,0,.45-1.75v-.2a3.18,3.18,0,0,0-.46-1.95,1.7,1.7,0,0,0-1.44-.59,1.52,1.52,0,0,0-1.32.67,3.33,3.33,0,0,0-.45,1.88,3.19,3.19,0,0,0,.45,1.86A1.54,1.54,0,0,0,93.66,26.8Zm11-5.83a2.38,2.38,0,0,1,2,.87,3.75,3.75,0,0,1,.7,2.44,3.81,3.81,0,0,1-.71,2.46,2.35,2.35,0,0,1-2,.88,2.88,2.88,0,0,1-1.15-.23,2.17,2.17,0,0,1-.87-.72h-.07l-.21.83h-.69V18.38h1V20.6c0,.49,0,.94-.05,1.33h.05A2.3,2.3,0,0,1,104.7,21Zm-.15.82a1.69,1.69,0,0,0-1.43.57,3.23,3.23,0,0,0-.44,1.92,3.22,3.22,0,0,0,.45,1.94,1.71,1.71,0,0,0,1.45.58,1.47,1.47,0,0,0,1.33-.65,3.31,3.31,0,0,0,.44-1.88,3.19,3.19,0,0,0-.44-1.87A1.54,1.54,0,0,0,104.55,21.79Zm3.5-.71h1l1.41,3.66a14.72,14.72,0,0,1,.57,1.81h.05c0-.2.15-.54.31-1s.7-2,1.6-4.45h1l-2.76,7.31a3.64,3.64,0,0,1-1,1.54,2,2,0,0,1-1.34.45,3.71,3.71,0,0,1-.88-.1V29.5a3.14,3.14,0,0,0,.72.07,1.48,1.48,0,0,0,1.43-1.12l.36-.91ZM121.9,27.5l-2.06-6.72h0c.07,1.37.11,2.28.11,2.74v4h-1.62V18.93h2.47l2,6.55h0L125,18.93h2.48V27.5h-1.7V23.45c0-.2,0-.42,0-.67s0-.91.08-2h0l-2.21,6.71Zm9-3.29a2.76,2.76,0,0,0,.32,1.47,1.33,1.33,0,0,0,2.07,0,2.79,2.79,0,0,0,.31-1.48,2.73,2.73,0,0,0-.31-1.46,1.17,1.17,0,0,0-1-.48,1.14,1.14,0,0,0-1,.48A2.7,2.7,0,0,0,130.88,24.21Zm4.53,0a3.52,3.52,0,0,1-.84,2.5,3.05,3.05,0,0,1-2.35.91,3.36,3.36,0,0,1-1.67-.41,2.75,2.75,0,0,1-1.1-1.19,4,4,0,0,1-.39-1.81,3.47,3.47,0,0,1,.84-2.49,3,3,0,0,1,2.35-.89,3.26,3.26,0,0,1,1.67.41,2.65,2.65,0,0,1,1.1,1.17A3.94,3.94,0,0,1,135.41,24.21Zm5.13-3.38a2.62,2.62,0,0,1,.61.05L141,22.55a2.58,2.58,0,0,0-.53-.05,1.86,1.86,0,0,0-1.33.44,1.58,1.58,0,0,0-.48,1.23V27.5h-1.78V21h1.35l.26,1.1h.09a2.39,2.39,0,0,1,.82-.88A2,2,0,0,1,140.54,20.83Zm6,6.67-.35-.89h-.05a2.65,2.65,0,0,1-.93.79,3.09,3.09,0,0,1-1.24.22,2,2,0,0,1-1.49-.54,2.08,2.08,0,0,1-.54-1.54,1.73,1.73,0,0,1,.73-1.53,4.19,4.19,0,0,1,2.2-.55l1.14,0v-.29a.89.89,0,0,0-1-1,4.79,4.79,0,0,0-1.85.47l-.59-1.2a5.29,5.29,0,0,1,2.51-.6,3.14,3.14,0,0,1,2,.58,2.1,2.1,0,0,1,.7,1.74V27.5Zm-.53-3-.69,0a2.17,2.17,0,0,0-1.16.28.86.86,0,0,0-.38.78c0,.51.28.76.86.76a1.34,1.34,0,0,0,1-.36A1.25,1.25,0,0,0,146,25Zm5.41,3h-1.79V18.38h1.79Zm1.8-8.24c0-.59.33-.88,1-.88s1,.29,1,.88a.89.89,0,0,1-.25.65,1,1,0,0,1-.73.22C153.51,20.13,153.18,19.84,153.18,19.26ZM155,27.5h-1.78V21H155Zm6.46-1.95a1.8,1.8,0,0,1-.71,1.54,3.44,3.44,0,0,1-2.09.53,7.06,7.06,0,0,1-1.22-.1,4.66,4.66,0,0,1-.94-.28V25.76a5.44,5.44,0,0,0,1.12.39,4.35,4.35,0,0,0,1.1.16c.65,0,1-.19,1-.56a.44.44,0,0,0-.13-.34,1.63,1.63,0,0,0-.44-.3c-.21-.11-.49-.24-.85-.39a5.42,5.42,0,0,1-1.11-.59,1.62,1.62,0,0,1-.51-.61,2.08,2.08,0,0,1-.16-.87,1.53,1.53,0,0,1,.67-1.34,3.28,3.28,0,0,1,1.92-.48,5.54,5.54,0,0,1,2.31.51l-.54,1.29c-.33-.14-.64-.25-.92-.34a2.94,2.94,0,0,0-.88-.14c-.52,0-.79.14-.79.43a.5.5,0,0,0,.25.41,7.16,7.16,0,0,0,1.12.53,4.79,4.79,0,0,1,1.13.58,1.65,1.65,0,0,1,.53.62A1.92,1.92,0,0,1,161.5,25.55Zm1.14,1.11a1,1,0,0,1,.26-.74,1.07,1.07,0,0,1,.77-.25,1,1,0,0,1,.75.25,1,1,0,0,1,.27.74,1,1,0,0,1-.27.74,1.23,1.23,0,0,1-1.51,0A1,1,0,0,1,162.64,26.66Zm3.6-7.4c0-.59.32-.88,1-.88s1,.29,1,.88a.88.88,0,0,1-.24.65,1.06,1.06,0,0,1-.73.22C166.56,20.13,166.24,19.84,166.24,19.26Zm1.86,8.24h-1.79V21h1.79Zm3.3-3.29a2.76,2.76,0,0,0,.32,1.47,1.13,1.13,0,0,0,1,.5,1.12,1.12,0,0,0,1-.49,2.79,2.79,0,0,0,.31-1.48,2.73,2.73,0,0,0-.31-1.46,1.15,1.15,0,0,0-1-.48,1.14,1.14,0,0,0-1,.48A2.7,2.7,0,0,0,171.4,24.21Zm4.53,0a3.52,3.52,0,0,1-.84,2.5,3,3,0,0,1-2.35.91,3.32,3.32,0,0,1-1.66-.41A2.84,2.84,0,0,1,170,26a4,4,0,0,1-.39-1.81,3.47,3.47,0,0,1,.84-2.49,3,3,0,0,1,2.35-.89,3.26,3.26,0,0,1,1.67.41,2.73,2.73,0,0,1,1.11,1.17A4.08,4.08,0,0,1,175.93,24.21Z" }, void 0)] }), void 0));
};
var ByMoralis = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "colour" : _b, _c = _a.width, width = _c === void 0 ? 250 : _c, style = _a.style;
    if (variant === "light") {
        return jsx(PoweredByLight, { style: __assign({ width: width }, style) }, void 0);
    }
    if (variant === "dark") {
        return jsx(PoweredByDark, { style: __assign({ width: width }, style) }, void 0);
    }
    return jsx(PoweredByColour, { style: __assign({ width: width }, style) }, void 0);
};

export { ByMoralis, MoralisContext, MoralisProvider, NoMoralisContextProviderError, NotAuthenticatedError, ReactMoralisError, ValidationError, useMoralis, useMoralisCloudFunction, useMoralisFile, useMoralisQuery, useMoralisSubscription, useMoralisWeb3Api, useMoralisWeb3ApiCall, useNewMoralisObject };
//# sourceMappingURL=index.esm.js.map
